import Track1 from "../../assets/ArabicVinylImg/arabicvinyl1.png"
import Track2 from "../../assets/ArabicVinylImg/arabicvinyl2.png"
import Track3 from "../../assets/ArabicVinylImg/arabicvinyl3.png"
import Track4 from "../../assets/ArabicVinylImg/arabicvinyl4.png"
import Track5 from "../../assets/ArabicVinylImg/arabicvinyl5.png"
import Track6 from "../../assets/ArabicVinylImg/arabicvinyl6.png"
import Track7 from "../../assets/ArabicVinylImg/arabicvinyl7.png"
import Track8 from "../../assets/ArabicVinylImg/arabicvinyl8.png"
import Track9 from "../../assets/ArabicVinylImg/arabicvinyl9.png"
import Track10 from "../../assets/ArabicVinylImg/arabicvinyl10.png"
import Track11 from "../../assets/ArabicVinylImg/arabicvinyl11.png"
import Track12 from "../../assets/ArabicVinylImg/arabicvinyl12.png"
import Track13 from "../../assets/ArabicVinylImg/arabicvinyl13.png"
import Track14 from "../../assets/ArabicVinylImg/arabicvinyl14.png"
import Track15 from "../../assets/ArabicVinylImg/arabicvinyl15.png"
import Track16 from "../../assets/ArabicVinylImg/arabicvinyl16.png"
import Track17 from "../../assets/ArabicVinylImg/arabicvinyl17.png"
import Track18 from "../../assets/ArabicVinylImg/arabicvinyl18.png"
import Track19 from "../../assets/ArabicVinylImg/arabicvinyl19.png"
import Track20 from "../../assets/ArabicVinylImg/arabicvinyl20.png"
import Track21 from "../../assets/ArabicVinylImg/arabicvinyl21.png"
import Track22 from "../../assets/ArabicVinylImg/arabicvinyl22.png"
const ArabicVinylData = [
    {
        id: "1",
        img: Track1,
        title: "Lebanon For Ever",
        artist: "Fairuz",
        price: "60",
        cat: "Fairuz",
        lang: "Arabic",
        category: "Arabic",
    },
    {
        id: "2",
        img: Track2,
        title: "Ila Aassi",
        artist: "Fairuz",
        price: "95",
        category: "Arabic",
    },
    {
        id: "3",
        img: Track3,
        title: "Christmas Hymns",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "4",
        img: Track4,
        title: "In Concert At The Olympia – Paris",
        artist: "Fairuz",
        price: "95",
        category: "Arabic",
    },
    {
        id: "5",
        img: Track5,
        title: "Best Of Sabah",
        artist: "Sabah",
        price: "60",
        category: "Arabic",
    },
    {
        id: "6",
        img: Track6,
        title: "Best Of Wadih El Safi",
        artist: "Wadih El Safi",
        price: "60",
        category: "Arabic",
    },
    {
        id: "7",
        img: Track7,
        title: "Highlights From The Popular Musical Play L’Auberge Du Bonheur / Nazl El Sourour",
        artist: "Ziad Rahbani",
        price: "60",
        category: "Arabic",
    },
    {
        id: "8",
        img: Track8,
        title: "Good Friday Eastern Sacred Songs",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "9",
        img: Track9,
        title: "At The Royal Festival Hall London",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "10",
        img: Track10,
        title: "La Gardienne Des Clefs – Baalbeck & Damascus 1972 – Highlights - LIVE",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "11",
        img: Track11,
        title: "Mais El Rim – Highlights – Piccadilly 1975",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "12",
        img: Track12,
        title: "Loulou – Highlights From The Popular Musical Play By The Rahbani Brothers– Piccadilly 1974",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "13",
        img: Track13,
        title: "Highlights From Al Mahatta – A Popular Musical Play By The Rahbani Brothers – Piccadilly 1973",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "14",
        img: Track14,
        title: "Belly Dance Fever",
        artist: "Elias Rahbani, Ziad Rahbani",
        price: "60",
        category: "Arabic",
    },
    {
        id: "15",
        img: Track15,
        title: "Mosaic Of TheOrient",
        artist: "Elias Rahbani",
        price: "60",
        category: "Arabic",
    },
    {
        id: "16",
        img: Track16,
        title: "Tribute To Oum Koulsoum by Omar Khorshid and his Magic Guitar",
        artist: "Omar Khorshid",
        price: "60",
        category: "Arabic",
    },
    {
        id: "17",
        img: Track17,
        title: "Rings for Sale – Le Vendeur De Bagues / Bayaa El Khawatem",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "18",
        img: Track18,
        title: "In America",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "19",
        img: Track19,
        title: "Jerusalem in my heart",
        artist: "Fairuz",
        price: "60",
        category: "Arabic",
    },
    {
        id: "20",
        img: Track20,
        title: "Washwishni",
        artist: "Fairuz",
        price: "40",
        category: "Arabic",
    },
    {
        id: "21",
        img: Track21,
        title: "Chillout Classics By Ziad Rahbani",
        artist: "Ziad Rahbani",
        price: "62",
        category: "Arabic",
    },
    {
        id: "22",
        img: Track22,
        title: "Legend: The Best of",
        artist: "Fairuz",
        price: "62",
        category: "Arabic",
    },
]
export default ArabicVinylData;